import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=4ced556b&scoped=true&"
import script from "./data-list.vue?vue&type=script&lang=js&"
export * from "./data-list.vue?vue&type=script&lang=js&"
import style0 from "./data-list.vue?vue&type=style&index=0&id=4ced556b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ced556b",
  null
  
)

export default component.exports